var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonChime16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/16/Arch_Amazon-Chime_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/16/Arch_Amazon-Chime_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/16/Business-Applications",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19,13.495 L15,12.339 L15,11.2 L19,12.364 L19,13.495 Z M16.849,17.382 L16.099,18.133 L14.112,14.572 L14.868,13.816 L16.849,17.382 Z M13.27,14 L11.284,14 C11.135,14 10.997,14.066 10.904,14.175 L10,13.271 L10,11.285 C10,11.135 9.934,10.997 9.825,10.905 L10.73,10 L12.716,10 C12.865,10 13.003,9.933 13.096,9.825 L14,10.729 L14,12.715 C14,12.865 14.066,13.002 14.175,13.095 L13.27,14 Z M11.637,19 L10.505,19 L11.66,15 L12.801,15 L11.637,19 Z M6.618,16.849 L5.867,16.098 L9.428,14.112 L10.184,14.868 L6.618,16.849 Z M5,11.636 L5,10.505 L9,11.661 L9,12.8 L5,11.636 Z M7.151,6.618 L7.901,5.867 L9.888,9.428 L9.132,10.183 L7.151,6.618 Z M12.363,5 L13.495,5 L12.34,9 L11.199,9 L12.363,5 Z M17.382,7.151 L18.133,7.902 L14.572,9.888 L13.816,9.132 L17.382,7.151 Z M19.64,11.508 L15.749,10.376 L19.197,8.453 C19.335,8.376 19.428,8.24 19.449,8.085 C19.471,7.93 19.419,7.773 19.308,7.662 L17.822,6.177 C17.665,6.019 17.421,5.985 17.226,6.094 L13.646,8.083 L14.641,4.639 C14.685,4.488 14.654,4.325 14.56,4.2 C14.465,4.074 14.317,4 14.16,4 L11.988,4 C11.766,4 11.57,4.147 11.508,4.36 L10.376,8.25 L8.452,4.802 C8.376,4.665 8.239,4.572 8.085,4.551 C7.925,4.526 7.773,4.581 7.662,4.692 L6.178,6.177 C6.02,6.335 5.985,6.578 6.094,6.773 L8.083,10.355 L4.639,9.359 C4.489,9.317 4.325,9.346 4.199,9.44 C4.074,9.535 4,9.682 4,9.84 L4,12.012 C4,12.234 4.146,12.43 4.36,12.492 L8.251,13.623 L4.803,15.547 C4.665,15.623 4.572,15.76 4.551,15.915 C4.529,16.07 4.581,16.226 4.692,16.337 L6.178,17.823 C6.336,17.981 6.58,18.015 6.774,17.906 L10.354,15.917 L9.359,19.361 C9.315,19.512 9.346,19.675 9.44,19.8 C9.535,19.926 9.683,20 9.84,20 L12.012,20 C12.234,20 12.43,19.853 12.492,19.64 L13.624,15.749 L15.548,19.198 C15.624,19.334 15.761,19.428 15.915,19.449 C16.076,19.473 16.228,19.418 16.338,19.307 L17.822,17.823 C17.98,17.665 18.015,17.421 17.906,17.226 L15.917,13.645 L19.361,14.641 C19.514,14.685 19.675,14.654 19.801,14.559 C19.926,14.465 20,14.317 20,14.16 L20,11.988 C20,11.766 19.854,11.57 19.64,11.508 L19.64,11.508 Z",
    id: "Amazon-Chime_Icon_16_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonChime16);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Chime_16.41a2c690d11c5cb1d5c6b2f9f6d55d3e.svg";
export { ForwardRef as ReactComponent };